export default __webpack_public_path__ + "ui/assets/fonts/Default-font-Medium.woff";